import React from 'react'
import {
  ButtonsGroup,
  DcButton,
  DcFlexBox,
  DcInput,
  PixelFactoryContext,
  PixelModal,
} from 'pixel-base'
import styled from 'styled-components'

import { updateInventory } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../../../decl.d'

const EditQuantity = (props) => {
  const { id, product_id, handleUpdate } = props

  const [data, setData] = React.useState<any>({
    count: '',
    status: 'on_hand',
    update_type: 'add',
    notes: '',
  })
  const [showNotesModal, setShowNotesModal] = React.useState(false)
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const updateQuantity = () => {
    showPageLoader()
    updateInventory(product_id, id, data).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.message) {
        showSuccess(res.response.message)
        handleUpdate(res.response.data)
      } else {
        showFailure(res.response.error)
      }
      setData({
        ...data,
        count: '',
      })
    })
  }
  React.useEffect(() => {
    setData({
      ...data,
      product_ids: [product_id],
      wh_id: id,
    })
  }, [])
  return (
    <DcFlexBox>
      <ButtonsGroup>
        <DcButton
          onClick={() => {
            setData({ ...data, update_type: 'add' })
          }}
          active={data.update_type === 'add'}
          variant={data.update_type === 'add' ? 'primary' : 'outline-primary'}
          size="sm"
        >
          Add
        </DcButton>
        <DcButton
          onClick={() => {
            setData({ ...data, update_type: 'set' })
          }}
          active={data.update_type === 'set'}
          variant={data.update_type === 'set' ? 'primary' : 'outline-primary'}
          size="sm"
        >
          Set
        </DcButton>
      </ButtonsGroup>
      <FormGroup>
        <DcInput
          inputSize="small"
          height="33px"
          required
          type={'number'}
          name={'ammount'}
          placeholder={'0'}
          min="0"
          isShowLabel={false}
          value={data.count}
          onChange={(e) => setData({ ...data, count: Number(e.target.value) })}
        />
      </FormGroup>
      <DcButton
        onClick={() => {
          if (data.count === '' && data.update_type === 'add') {
            showFailure('add 0 has no effect')
          } else if (data.update_type !== '') {
            setShowNotesModal(true)
          } else {
            showFailure('Please select update type')
          }
        }}
        size="sm"
      >
        Save
      </DcButton>
      {showNotesModal && (
        <PixelModal
          handleClose={() => {
            setShowNotesModal(false)
          }}
          size={'md'}
          title={'Add Notes'}
          show={showNotesModal}
        >
          <DcFlexBox>
            <DcInput
              inputSize="small"
              height="33px"
              required
              type={'string'}
              name={'notes'}
              placeholder={'Notes'}
              value={data.notes}
              onChange={(e) => setData({ ...data, notes: e.target.value })}
            />
            &nbsp;
            <DcButton
              size="sm"
              onClick={() => {
                setShowNotesModal(false)
                updateQuantity()
              }}
            >
              Save
            </DcButton>
          </DcFlexBox>
        </PixelModal>
      )}
    </DcFlexBox>
  )
}
const FormGroup = styled.div`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  width: 45%;
  margin: 0 10px 0 10px;
  .full-width {
    flex-grow: 1;
  }
`
export default EditQuantity
